import angular from 'angular';

class ModalDeleteCompanyCtrl {
  /*@ngInject*/
  constructor(PrincipalSvc, logger) {
    this.PrincipalSvc = PrincipalSvc;
    this.logger = logger;
  }

  $onInit() {
    this.legalEntity = angular.copy(this.resolve.legalEntity);
  }

  deleteCompany() {
    this.PrincipalSvc.deleteCompany(this.legalEntity.id).then(
      data => {
        this.logger.success('success.delete', data, null, { entityName: this.legalEntity.name });
        this.modalInstance.close();
      },
      () => {
        this.logger.error('error.delete');
        this.cancel();
      }
    );
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('modalDeleteCompany', {
  templateUrl: require('./modal-delete-company.html'),
  controller: ModalDeleteCompanyCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
